import { MooringCategoryType } from './MooringArticleCategoryType';
import { ArticleTypeVariant } from './MooringArticleType';

export const MooringComponentType = {
  anchorLine: 'anchorLine',
  gridLine: 'gridLine',
  buoy: 'buoy',
  bridle: 'bridle',
  cage: 'cage',
} as const;

export type MooringComponentType = (typeof MooringComponentType)[keyof typeof MooringComponentType];

export class MooringComponent {
  Id: number;
  // ArticleId: number;
  ArticleProductId: number;
  Quantity: number;
  HasLoadConstraint: boolean;
  UtilizationFactor?: number;
  MaterialFactor?: number;
  IsForCounterWeight: boolean;
  HasKnot: boolean;
  ProductName: string;
  CategoryName: string;
  TypeName: string;
  ProductTypeName?: string;
  MBL?: number;
  WLL?: number;
  SortIndex: number;
  //
  CategoryType: MooringCategoryType;
  TypeVariant: ArticleTypeVariant;
  PrimaryDimension: number;
  SecondaryDimension?: number;
}

export class CreateUpdateMooringComponent {
  Id?: number;
  ArticleProductId: number;
  SortIndex: number;
  IsForCounterWeight: boolean;
  HasKnot: boolean;
  HasLoadConstraint: boolean;
}
